
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/recensioni",
      function () {
        return require("private-next-pages/[region]/[resort]/recensioni.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/recensioni"])
      });
    }
  